import PropTypes from 'prop-types';
import React from 'react';

const SVG = ({ color }) => (
  <svg fill="none" height="14" viewBox="0 0 16 14" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.2159 12.529L8.88189 0.654012C8.50589 -0.0519882 7.49389 -0.0519882 7.11689 0.654012L0.783885 12.529C0.428885 13.195 0.911885 14 1.66689 14H14.3339C15.0879 14 15.5709 13.195 15.2159 12.529ZM7.99989 12C7.44789 12 6.99989 11.552 6.99989 11C6.99989 10.448 7.44789 10 7.99989 10C8.55189 10 8.99989 10.448 8.99989 11C8.99989 11.552 8.55189 12 7.99989 12ZM8.99989 9.00001H6.99989V5.00001H8.99989V9.00001Z"
      fill={color}
    />
  </svg>
);

SVG.propTypes = {
  color: PropTypes.string,
};

SVG.defaultProps = {
  color: 'var(--ds-color-warning, #f68006)',
};

export default SVG;
